const { flatMap } = require('./arrays')
const {
  formatPhoneMask,
  formatIdMask,
 } = require('./masks')
const replaceSpecialChars = require('./removeCaracteres')
const removeHTML = require('./removeHTML')
const {
  slugfy,
  capitalize,
  htmlentities,
  serializeUrls,
  removeLastChar,
  formatTextToNumbers,
  normalizeText,
} = require('./strings')
const { isHome, isMobile, isMobileLarge, isUrl, isExternalLink } = require('./validators')
const mediaQuery = require('./mediaQuery')
const { sendSlack, sendFormattedSlack, slackColors } = require('./slack')
const { get, set } = require('./redis')
const debounce = require('./debounce')

module.exports = {
  flatMap,
  formatPhoneMask,
  formatIdMask,
  replaceSpecialChars,
  removeHTML,
  slugfy,
  capitalize,
  htmlentities,
  serializeUrls,
  removeLastChar,
  formatTextToNumbers,
  normalizeText,
  isHome,
  isMobile,
  isMobileLarge,
  isUrl,
  isExternalLink,
  mediaQuery,
  sendSlack,
  sendFormattedSlack,
  slackColors,
  get,
  set,
  debounce,
}
